/*
* Pipeline Theme
*
* Use this file to add custom Javascript to Pipeline.  Keeping your custom
* Javascript in this fill will make it easier to update Pipeline. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*
*/


(function() {

  // Below are example event listeners.  They listen for theme events that Pipeline
  // fires in order to make it easier for you to add customizations.

  // Keep your scripts inside this IIFE function call to avoid leaking your
  // variables into the global scope.


  document.addEventListener('theme:variant:change', function(event) {
    // You might use something like this to write a pre-order feature or a
    // custom swatch feature.
    var variant = event.detail.variant;
    var container = event.target;
    if (variant) {
      console.log('Container ———————— ↓');
      console.log(container);
      console.log('Variant —————————— ↓');
      console.log(variant);
      // ... update some element on the page
    }
    /*
    let size_label = document.querySelector('[data-select-label="Size"] .radio__fieldset');
    size_label.classList.remove('flip-arrow');
    size_label.querySelector('.radio__inputs').classList.remove('show');
    */
  });

  document.addEventListener('theme:cart:change', function(event) {
    // BXZ code
    setTimeout(function() {
      if (GetCurrency) GetCurrency();
    }, 500);
    // BXZ code
    
    var cart = event.detail.cart;
    if (cart) {
      console.log('Cart ———————————— ↓');
      console.log(cart);
      document.querySelector('.cart__drawer__title .cart-count').textContent = cart.item_count;
    }
    if(cart.item_count == 0) {
      document.querySelector('.cart__drawer').classList.add('cart--empty');
      document.querySelector('.cart__drawer__title .cart-count-wrapper').classList.add('hide');
    } else {
      document.querySelector('.cart__drawer').classList.remove('cart--empty');
      document.querySelector('.cart__drawer__title .cart-count-wrapper').classList.remove('hide');
    }
  });
  // Fired when page loads to update header values
  document.addEventListener('theme:cart:init', (e) => {
    console.log('theme:cart:init');
    console.log(e);
  });

  document.addEventListener('theme:popdown:search', (e) => {
    var query_list = document.querySelectorAll('.search__predictive__suggestions-list li');
    query_list.forEach(function(item) {
      item.addEventListener('click', function(e) {
        var input_element = item.parentElement.parentElement.parentElement.parentElement;
        input_element.querySelector('.search-input').value = item.innerHTML;
        input_element.querySelector('.search-input').focus();
      });
    });
    document.querySelectorAll('.search__predictive__filters div').forEach(function(item) {
      item.addEventListener('click', function(e) {
        var input_element = item.parentElement.parentElement.parentElement.parentElement;
        var filter_name = this.innerHTML.replace(/\s/g, '');
        input_element.querySelector('.search-input').value += ' ' + filter_name;
        input_element.querySelector('.search-input').focus();
      });
    });
    document.querySelector('.search__predictive__clear button').addEventListener('click', function(e) {
      document.querySelector('.search-popdown').classList.remove('visible-filters');
    });
  });

  document.addEventListener('theme:search:performed', function(event) {
    var searchTerm = event.detail.search;
    searchTerm = searchTerm.toLowerCase();
    if(searchTerm == 'linen' || searchTerm == 'swim') {
      document.querySelector('.search-popdown').classList.add('visible-filters');
    }
    else {
      document.querySelector('.search-popdown').classList.remove('visible-filters');
    }
  });

  document.addEventListener('theme:search:filters', function(event) {
    
  });

  document.addEventListener('theme:search:performedcache', function(event) {
    var searchTerm = event.detail.search;
    searchTerm = searchTerm.toLowerCase();
    if(searchTerm == 'linen' ) {
      document.querySelector('.search-popdown').classList.add('visible-filters');
    }
    else {
      document.querySelector('.search-popdown').classList.remove('visible-filters');
    }
  });

  document.addEventListener('theme:recent-products-search:added', function(event) {
    /*var products_recent = event.detail.products_recent;
    alert(products_recent);
    var item_products = document.querySelector('.recent__wrapper-search .product-grid')
      item_products.innerHTML += products_recent;
      item_products.style.display = "block";
    */
  }); 

  document.addEventListener('theme:recent-products:added', function(event) {
    const node = document.createElement("h2");
    const textnode = document.createTextNode("Recently Viewed");
    node.appendChild(textnode);
    document.querySelector('.recent__wrapper-search').prepend(node)
  });

  document.addEventListener('theme:scroll:lock', (e) => {
    console.log('theme:cart:lock');
  });

  window.addEventListener('load', (event) => {
  let collection_nav = document.querySelector('.shopify-section-group-group-header.collection_list_custom');
  if(collection_nav.classList.contains('collection_list_custom_class')) {
    let collection_nav_desktop_section = collection_nav.innerHTML;
    let collection_nav_mobile_location = document.querySelector(".collection-link-nav").innerHTML;
    document.querySelector(".collection-link-nav").innerHTML = collection_nav_desktop_section;
    collection_nav.innerHTML = '';
  }
  
  });
  /*
  function AddActiveClass() {
  const sections = document.querySelectorAll('.product__media');
  var i = 0;
  sections.forEach(
    function(section) {
      var distanceFromTop = section.getBoundingClientRect().top;
      //var span = section.parentElement.querySelector('.desktop-dots');
      i++;
      if(distanceFromTop >= 0) {
        section.classList.add('image_active');
      } else {
        section.classList.remove('image_active');
      }
    }
  );
}
document.addEventListener('scroll', AddActiveClass);*/

  if(document.querySelector('body').classList.contains('template-product') && window.innerWidth > 767) {
   var observer = new IntersectionObserver(function(entries) {
      entries[0].target.classList.remove('dots-visible');
      if(entries[0].isIntersecting === true) {
         entries[0].target.classList.add('dots-visible');
      }
    }, { threshold: [0.4] });
    
    const blogs = document.querySelectorAll('.product__media');
    blogs.forEach(blog => observer.observe(blog));
  }

  if(document.querySelector('body').classList.contains('template-product')) {
    /*
    let size_label = document.querySelector('[data-select-label="Size"] .radio__legend');
    size_label.addEventListener('click', function(e) {
      var radio_input = size_label.parentElement;
      radio_input.classList.toggle('flip-arrow');
      radio_input.querySelector('.radio__inputs').classList.toggle('show');
    });
    */
  
    var window_height = window.innerHeight - 90;
    var description_height = document.querySelector('.product__block__description').clientHeight;
    var inner_height = document.querySelector('.product__inner').clientHeight + description_height + 100;
    if (window_height > inner_height) {
      document.querySelector('.product__inner').style.height = 'calc(100vh - 90px)';
    }
    if(document.querySelector('.product__media__wrapper').classList.contains('media_count_1')) {
      document.querySelector('.product__inner').style.height = '';
    }

    var men_sizing_tab = document.querySelector('.men-sizing-tab');
    men_sizing_tab.addEventListener('click', function(e) {
      document.querySelector('.men-sizing-chart').classList.add('active');
      document.querySelector('.men-sizing-tab').classList.add('active');
      if(document.querySelector('.women-sizing-chart').classList.contains('active')) {
        document.querySelector('.women-sizing-chart').classList.remove('active');
        document.querySelector('.women-sizing-tab').classList.remove('active');
      }
    });
    var women_sizing_tab = document.querySelector('.women-sizing-tab');
    women_sizing_tab.addEventListener('click', function(e) {
      document.querySelector('.women-sizing-chart').classList.add('active');
      document.querySelector('.women-sizing-tab').classList.add('active');
      if(document.querySelector('.men-sizing-chart').classList.contains('active')) {
        document.querySelector('.men-sizing-chart').classList.remove('active');
        document.querySelector('.men-sizing-tab').classList.remove('active');
      }
    });
    
    if(document.querySelector('#description-main a').getAttribute('target') === '_blank') {
      document.querySelector('#description-main a').removeAttribute('target');
    }
    
  }

  if(document.querySelector('body').classList.contains('template-collection') && window.innerWidth < 768) {
    document.querySelectorAll('.sidebar__filter__group .sidebar__heading').forEach(function(item) {
      if(item.classList.contains('accordion-is-open')) {
        item.classList.remove('accordion-is-open');
      }
    });
  }

  // Hide sort by on click
  if(document.querySelector('body').classList.contains('template-collection')) {
    document.querySelector('.popout-list .icon-close').addEventListener('click', function(e) {
      if(document.querySelector('#sort-list').classList.contains('popout-list--visible')) {
        document.querySelector('#sort-list').classList.remove('popout-list--visible');
      }
    });
  }

  if(document.querySelector('body').classList.contains('template-customers-account')) {
    document.querySelector('.orders').addEventListener('click', function(e) {
      document.querySelector('.orders-list').classList.toggle('active');
    });
    document.querySelector('.address').addEventListener('click', function(e) {
      document.querySelector('.address-list').classList.toggle('active');
    });
  }
  
  document.querySelector('.select-size-mobile .icon-close').addEventListener('click', function(e) {
    if(document.querySelector('.select-popout__list').classList.contains('popout-list--visible')) {
      document.querySelector('.select-popout__list').classList.remove('popout-list--visible');
    }
  });

  /*
  const addMaximumScaleToMetaViewport = () => {
  const el = document.querySelector('meta[name=viewport]');

  if (el !== null) {
    let content = el.getAttribute('content');
    let re = /maximum\-scale=[0-9\.]+/g;

    if (re.test(content)) {
        content = content.replace(re, 'maximum-scale=1.0');
    } else {
        content = [content, 'maximum-scale=1.0'].join(', ')
    }

    el.setAttribute('content', content);
  }
};

const disableIosTextFieldZoom = addMaximumScaleToMetaViewport;

// https://stackoverflow.com/questions/9038625/detect-if-device-is-ios/9039885#9039885
const checkIsIOS = () =>
  /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;

if (checkIsIOS()) {
  disableIosTextFieldZoom();
}
  */
  
  // Debounced scroll listeners.  Up and down only fire on direction changes
  // These events are useful for creating sticky elements and popups.
  document.addEventListener('theme:scroll', e => { console.log(e); });
  document.addEventListener('theme:scroll:up', e => { console.log(e); });
  document.addEventListener('theme:scroll:down', e => { console.log(e); });

  // Debounced resize listener to bundle changes that trigger document reflow
  document.addEventListener('theme:resize', e => { console.log(e); });

  // BXZ code
  document.addEventListener('theme:drawer:open', (e) => {
      setTimeout(function() {
        if (GetCurrency) GetCurrency();
      }, 500);
  });
  // BXZ code
  
  // Locks and unlocks page scroll for modals and drawers
  // These are commented out because firing them will lock the page scroll
  // the lock event must set `detail` to the modal or drawer body so the 
  // scroll locking code knows what element should maintain scoll. 
  // document.dispatchEvent(new CustomEvent('theme:scroll:lock', {bubbles: true, detail: scrollableInnerElement}));
  // document.dispatchEvent(new CustomEvent('theme:scroll:unlock', {bubbles: true}));


  // ^^ Keep your scripts inside this IIFE function call to avoid leaking your
  // variables into the global scope.
})();
